export default function ballsToOvers(balls, ballsPerOver) {
  if (!balls || !ballsPerOver) return 0;

  return (
    Math.floor(
      (Math.floor(balls / ballsPerOver) + 0.1 * (balls % ballsPerOver)) * 10
    ) / 10
  );
}
